/**
 * Sion resource types.
 *
 * @readonly
 * @enum {string}
 * @property {string} STATEMENT Represents the Statement resource type.
 * @property {string} RESERVATION Represents the Reservation resource type.
 * @property {string} TRANSFER Represents the Transfer resource type.
 * @property {string} AGENCY Represents the Agency resource type.
 * @property {string} SUPPLIER Represents the Supplier resource type.
 */
export const SionResourceTypes = Object.freeze({
  RESERVATION: 'reservation',
  TRANSFER: 'transfer',
  STATEMENT: 'statement',
  AGENCY: 'agency',
});

/**
 * Enum of Sion resource type meta data.
 *
 * @readonly
 * @enum {object}
 * @property {string} icon Represents the icon of the resource type.
 * @property {string} label Represents the label of the resource type.
 * @property {string} labelPlural Represents the plural label of the resource type.
 */
export const SionResourceTypeMeta = Object.freeze({
  [SionResourceTypes.STATEMENT]: { icon: 'file-check', label: 'Statement', labelPlural: 'Statements' },
  [SionResourceTypes.RESERVATION]: { icon: 'calendar-check', label: 'Reservation', labelPlural: 'Reservations' },
  [SionResourceTypes.TRANSFER]: { icon: 'bank-note', label: 'Transfer', labelPlural: 'Transfers' },
  [SionResourceTypes.AGENCY]: { icon: 'building', label: 'Agency', labelPlural: 'Agencies' },
});

/**
 * Sion user type values.
 *
 * @readonly
 * @enum {string}
 * @property {string} SUPPLIER Represents the Supplier user type.
 * @property {string} AGENCY Represents the Agency user type.
 */

export const SionUserTypes = Object.freeze({
  SUPPLIER: 'SUPPLIER',
  AGENCY: 'AGENCY',
});

/**
 * Sion terms of use urls.
 *
 * @readonly
 * @enum {string}
 * @property {string} SUPPLIER Represents the Supplier brand variant.
 * @property {string} AGENCY Represents the Agency brand variant.
 */

export const SionTermsOfUse = Object.freeze({
  SUPPLIER: {
    url: 'https://www.sioncentral.com/supplier/terms-and-conditions',
    title: `Sion's Terms & Conditions`,
  },
  AGENCY: {
    url: 'https://www.sioncentral.com/supplier/beneficiary-terms-of-use',
    title: `Sion's Terms of Use`,
  },
});
